import Immutable from 'immutable';

const IdpApprovalListRecord = Immutable.Record({
  studentIDPId: undefined,
});

class IdpApprovalList extends IdpApprovalListRecord { }

export default IdpApprovalList;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpApprovalList/model.js